export const usdt = (m) => {
  if (m == null) return "—";
  const neg = m < 0;
  const a = Math.abs(m);
  const whole = Math.floor(a / 1e6).toLocaleString("en-US");
  const frac = String(Math.floor((a % 1e6) / 1e4)).padStart(2, "0");
  return `${neg ? "-" : ""}${whole}.${frac} USDT`;
};

export const LIMIT_LABELS = {
  min_deposit: "Minimum deposit", max_per_deposit: "Max per deposit", daily_deposit: "Daily deposits", monthly_deposit: "Monthly deposits",
  max_balance: "Max stored balance", max_order: "Max per order", daily_spend: "Daily spend", monthly_spend: "Monthly spend",
};

export const idemKey = () => `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
